import { useMoralis } from 'react-moralis';
import { Link } from 'react-router-dom';

const Nav = () => {
  const { isAuthenticated, authenticate, logout } = useMoralis();

  return (
    <div className='flex w-full justify-between items-center py-8'>
      <h1 className='font-extrabold uppercase text-xl xl:text-2xl py-2'>
        <Link to='/' className='lilita'>
          The DAM Project
        </Link>
      </h1>
      {!isAuthenticated ? (
        <button
          className='py-2 px-3 border border-gray-900 rounded-xl font-medium text-sm xl:text-base'
          onClick={() => authenticate()}
        >
          Connect
        </button>
      ) : (
        <div className='flex justify-center items-center'>
          <button
            className='py-2 px-3 border border-gray-900 rounded-xl font-medium text-sm xl:text-base mr-4'
            onClick={() => logout()}
          >
            logout
          </button>
          <button className='h-9 w-9 xl:h-12 xl:w-12'>
            <Link to='/profile'>
              <img
                src='https://img.icons8.com/external-bearicons-outline-color-bearicons/64/000000/external-user-essential-collection-bearicons-outline-color-bearicons.png'
                className='h-full w-full'
              />
            </Link>
          </button>
        </div>
      )}
    </div>
  );
};

export default Nav;
